import React, { FC } from 'react'

const Quote: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="61"
    height="55"
    viewBox="0 0 61 55"
    fill="none"
  >
    <path
      fill="#E6E8ED"
      fillRule="evenodd"
      d="M11 40.967c-3.2 4.4-6.8 7.8-10.8 10.2l2.2 3.2C10.8 50.233 17 45.1 21 38.967c4.133-6 6.2-12.734 6.2-20.2 0-5.467-1.4-9.867-4.2-13.2-2.667-3.467-6.333-5.2-11-5.2-3.333 0-6.2 1.133-8.6 3.4C1.133 5.9 0 8.633 0 11.967c0 3.333 1.133 6.2 3.4 8.6 2.4 2.266 5.267 3.4 8.6 3.4 1.333 0 2.333.333 3 1 .667.8 1 1.8 1 3 0 4.4-1.667 8.733-5 13Zm33 0c-3.2 4.4-6.8 7.8-10.8 10.2l2.2 3.2C43.8 50.233 50 45.1 54 38.967c4.133-6 6.2-12.734 6.2-20.2 0-5.467-1.4-9.867-4.2-13.2-2.667-3.467-6.333-5.2-11-5.2-3.333 0-6.2 1.133-8.6 3.4-2.267 2.133-3.4 4.866-3.4 8.2 0 3.333 1.133 6.2 3.4 8.6 2.4 2.266 5.267 3.4 8.6 3.4 1.333 0 2.333.333 3 1 .667.8 1 1.8 1 3 0 4.4-1.667 8.733-5 13Z"
      clipRule="evenodd"
    />
  </svg>
)

export default Quote
